import { useEffect, useState } from 'react';
import { Dialog } from '../contasis';

interface SessionExpirationModalProps {
  isOpen: boolean;
  timeRemaining: number;
  onContinue: () => void;
  onLogout: () => void;
}

export function SessionExpirationModal({
  isOpen,
  timeRemaining,
  onContinue,
  onLogout,
}: SessionExpirationModalProps) {
  const [displayTime, setDisplayTime] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    const updateDisplay = () => {
      const seconds = Math.max(0, Math.floor(timeRemaining / 1000));
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      setDisplayTime(`${minutes}:${remainingSeconds.toString().padStart(2, '0')}`);
    };

    updateDisplay();

    const interval = setInterval(updateDisplay, 1000);

    return () => clearInterval(interval);
  }, [isOpen, timeRemaining]);

  if (!isOpen) return null;

  return (
    <Dialog
      type="warning"
      title="Tu sesión está por expirar"
      confirmText="Continuar sesión"
      cancelText="Cerrar sesión"
      onConfirm={onContinue}
      onClose={onLogout}
    >
      <div className="leading-[1.6]">
        Tu sesión expirará en{' '}
        <span className="font-semibold text-primary">{displayTime}</span>.
        <br />
        ¿Deseas continuar trabajando o cerrar sesión?
      </div>
    </Dialog>
  );
}
